"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinUrl = void 0;
const url_join_1 = __importDefault(require("url-join"));
function joinUrl(...args) {
    return url_join_1.default(args);
}
exports.joinUrl = joinUrl;
